import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

import DateBox from 'components/DateBox';
import Image from 'components/Image';
import Link from 'components/Link';
import Reviewer from 'components/Reviewer';

import { CASE_STUDY_URL } from 'lib/urls';

import * as S from '../CaseStudyItem/styles';

interface ICaseStudyItem {
  detailsPage?: boolean;
  caseStudy: {
    title: string;
    reviewerName?: string;
    companyPosition?: string;
    companyUrl?: string;

    companyLogo?: {
      url: string;
      alt?: string;
      responsiveImage?: {
        aspectRatio?: number;
      };
    };

    reviewerAvatar?: {
      url: string;
      alt?: string;
    };

    solution: string;
    review: string;
    project: string;

    date: string;
    slug?: string;
  };
}

const CaseStudyItem = ({ detailsPage, caseStudy }: ICaseStudyItem) => {
  const companyLogoAspectRadio = caseStudy.companyLogo?.responsiveImage?.aspectRatio;

  return (
    <S.StyledContentBox>
      {!detailsPage && (
        <S.ReviewerLogo>
          {companyLogoAspectRadio && caseStudy.companyLogo && (
            <Image
              src={caseStudy.companyLogo.url}
              height={96}
              width={96 * companyLogoAspectRadio}
            />
          )}
        </S.ReviewerLogo>
      )}

      {detailsPage && <h1>{caseStudy.title}</h1>}

      {/* TODO: Fix when remove old global style */}
      {!detailsPage && caseStudy.slug && (
        <Link href={CASE_STUDY_URL({ slug: caseStudy.slug })} style={{ color: 'black' }}>
          <S.HeadingLine>{caseStudy.title}</S.HeadingLine>
        </Link>
      )}
      {!detailsPage && !caseStudy.slug && <S.HeadingLine>{caseStudy.title}</S.HeadingLine>}

      <S.DateWrapper>
        <DateBox date={caseStudy.date} showDay={false} />
      </S.DateWrapper>

      <S.Grid>
        <S.Column>
          <S.SectionTitle>The Solution</S.SectionTitle>
          <S.Solution>{caseStudy.solution}</S.Solution>
        </S.Column>

        <S.Column>
          <S.SectionTitle>The Project</S.SectionTitle>
          <S.Project>{caseStudy.project}</S.Project>
        </S.Column>

        <S.Column>
          <S.SectionTitle>The Review:</S.SectionTitle>
          <S.Review>{caseStudy.review}</S.Review>
        </S.Column>
      </S.Grid>

      <S.CtaGrid>
        <S.Reviewer>
          <Reviewer
            name={caseStudy.reviewerName}
            workPosition={caseStudy.companyPosition}
            avatarUrl={caseStudy.reviewerAvatar?.url}
          />
        </S.Reviewer>

        {detailsPage && (
          <S.ReviewerLogo>
            {companyLogoAspectRadio && caseStudy.companyLogo && (
              <Image
                src={caseStudy.companyLogo.url}
                height={96}
                width={96 * companyLogoAspectRadio}
              />
            )}
          </S.ReviewerLogo>
        )}
      </S.CtaGrid>

      <S.CtaContainer>
        {caseStudy.slug && !detailsPage && (
          <S.CaseStudyButton href={CASE_STUDY_URL({ slug: caseStudy.slug })}>
            <S.StyledFontAwesomeIcon icon={faExternalLinkAlt} />
            Read Case Study
          </S.CaseStudyButton>
        )}
      </S.CtaContainer>
    </S.StyledContentBox>
  );
};

export default CaseStudyItem;
